import { useEffect, useState } from 'react'

// Custom hook that determines if the code is running on the client side
// Use to avoid hydration issues with server-rendered content
export function useIsClient() {
  const [isClient, setClient] = useState(false)

  useEffect(() => {
    setClient(true)
  }, [])

  return isClient
}
